import { Option } from '@acorn-portal/shared/src/store/referenceData.slice';
import { TAXI_USAGE_CODES } from '@acorn-portal/shared/src/utils/constants';

/**
 * Filters out taxi usage codes from the provided vehicle options.
 * Typically used on PC or CV change journeys, where taxi usage is not applicable.
 *
 * @param vehicleOptions - An array of vehicle usage options - typically the master list from ICE lookup.
 * @returns An array of vehicle usage options excluding taxi usage codes - currently listed as '15' and '17'.
 */
export const getPCCVUsageOptions = (vehicleOptions: Option[]): Option[] => {
	const filteredOptions = vehicleOptions.filter((option) => {
		if (!option.value) return false;
		return !TAXI_USAGE_CODES.includes(option.value as string);
	});
	return filteredOptions;
};
